import { isVasteKamer } from '@tolk/shared';

/**
 * Wanneer een gesprek verloopt, in gewone woorden.
 *
 * MET DE DAG ERBIJ, EN DAT IS EEN LES UIT DIT PROJECT. Op 7 september 2026 las
 * een kamer als "aangemaakt en verlopen op dezelfde seconde", omdat er alleen
 * een TIJDSTIP stond en niet de datum; die kamer verliep zeven dagen later op
 * dezelfde klokstand. Een gesprek mag hier zeven dagen geldig zijn, dus
 * "verloopt om 17:44" is precies dezelfde val - het leest als vanavond.
 *
 * In lib en niet in het component: dit is de enige echte rekenregel van de
 * kamerlijst, en een rekenregel met randgevallen hoort toetsbaar te zijn.
 */
export function verlooptTekst(expiresAt: number, nu = Date.now()): string {
  // Een vaste kamer heeft het jaar 9999 als einddatum. Dat als datum tonen
  // leest als een fout; in woorden zegt het wat het is.
  if (isVasteKamer(expiresAt)) return 'nooit (vaste kamer)';

  const klok = new Date(expiresAt).toLocaleTimeString('nl-NL', {
    hour: '2-digit',
    minute: '2-digit',
  });

  // Vergelijken op de KALENDERDAG en niet op "binnen 24 uur". Om 23:00 is
  // morgenochtend 08:00 dichterbij dan vanavond 23:30, maar het is wel degelijk
  // een andere dag - en dat is wat je wilt weten als je inschat of je er nog
  // bij kunt.
  const dagVerschil = Math.round(
    (new Date(expiresAt).setHours(0, 0, 0, 0) - new Date(nu).setHours(0, 0, 0, 0)) / 86_400_000,
  );

  // Alles wat al voorbij is valt ook onder "vandaag". De lijst toont alleen
  // gesprekken die nog lopen, dus dat geval hoort er niet te zijn; komt het er
  // toch, dan is "vandaag om 09:12" duidelijker dan een verzonnen verleden tijd.
  if (dagVerschil <= 0) return `vandaag om ${klok}`;
  if (dagVerschil === 1) return `morgen om ${klok}`;

  const datum = new Date(expiresAt).toLocaleDateString('nl-NL', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
  return `${datum} om ${klok}`;
}
